module.exports = __webpack_public_path__ + "static/media/03_01_05.2a0a5615.png";